import { FC, PropsWithChildren } from 'react';
import { cn } from '@/utils/classNames.ts';
import AppLogo from '@/components/ui/AppLogo/AppLogo.tsx';
import { PropsWithClassName } from '@/types/PropsWithClassName';

type BrandCardSideContentType = {
  contentClassName?: string;
};

const BrandCardSideContent: FC<PropsWithChildren<PropsWithClassName<BrandCardSideContentType>>> = ({
  children,
  className,
  contentClassName,
}) => {
  return (
    <div
      className={cn(
        'grid grid-cols-2 shadow-xl rounded-2xl max-w-full w-[1048px] md:min-h-[500px] lg:min-h-[624px]',
        className
      )}
    >
      <div className="col-span-2 md:col-span-1 flex items-center justify-center p-8 bg-journi-black rounded-bl-none rounded-br-none rounded-l-2xl rounded-r-2xl md:rounded-bl-2xl md:rounded-r-none">
        <AppLogo.LogoOnly className="w-[75px] md:w-[200px] max-w-full" />
      </div>
      <div
        className={cn(
          'col-span-2 md:col-span-1 flex flex-col justify-center items-center gap-4 p-4 lg:p-10 bg-journi-theme-light rounded-bl-2xl rounded-br-2xl md:rounded-bl-none md:rounded-r-2xl',
          contentClassName
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default BrandCardSideContent;
